angular.module('app').factory('SettlementSearchFormService', function () {
    let fac = {
        searchSettlements: searchSettlements
    };
    function searchSettlements(model) {
        let testers = [
            { value: '-1', name: 'All Testers' },
            { value: '2', name: 'Peter' },
            { value: '3', name: 'John' }
        ];
        // An array of our form fields with configuration
        // and options set. We make reference to this in
        // the 'fields' attribute on the  element
        let form = [
            {
                className: 'row',
                fieldGroup: [
                    {
                        className: 'col-xs-3',
                        type: 'select',
                        key: 'testerId',
                        templateOptions: {
                            type: '',
                            label: 'Select a Tester',
                            required: true,
                            placeholder: '',
                            description: 'Select a tester',
                            options: testers
                        },
                        defaultValue: '',
                        expressionProperties: {},
                        validators: {},
                        validation: {
                            messages: {}
                        }
                    },
                    {
                        className: 'col-xs-2',
                        type: 'datepicker',
                        key: 'dateFm',
                        templateOptions: {
                            type: '',
                            label: 'DateFm',
                            required: true,
                            placeholder: '',
                            description: '',
                            options: [],
                            datepickerOptions: {
                                format: ''
                            }
                        },
                        defaultValue: '',
                        expressionProperties: {},
                        validators: {},
                        validation: {
                            messages: {}
                        }
                    },
                    {
                        className: 'col-xs-2',
                        type: 'datepicker',
                        key: 'dateTo',
                        templateOptions: {
                            type: '',
                            label: 'Date To',
                            required: true,
                            placeholder: '',
                            description: '',
                            options: [],
                            datepickerOptions: {
                                format: ''
                            }
                        },
                        defaultValue: '',
                        expressionProperties: {},
                        validators: {},
                        validation: {
                            messages: {}
                        }
                    }
                ]
            }
        ];
        return form;
    }
    return fac;
});
